
const serverURL = 'https://app.iat.v2.singular-it-test.de/';

export default  serverURL;
